'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 40;\n  background-color: rgba(0,0,0,0);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: background-color 1s;\n  .close-button {\n    transition: opacity 1s;\n    opacity: 0;\n  }\n  aside {\n    transform: translateY(100vh);\n    transition: transform 1s;\n  }\n  &.active {\n    background-color: rgba(0,0,0,0.75);\n    aside {\n      transform: translateY(0vh);\n    }\n    .close-button {\n      opacity: 1;\n    }\n  }\n'], ['\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 40;\n  background-color: rgba(0,0,0,0);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: background-color 1s;\n  .close-button {\n    transition: opacity 1s;\n    opacity: 0;\n  }\n  aside {\n    transform: translateY(100vh);\n    transition: transform 1s;\n  }\n  &.active {\n    background-color: rgba(0,0,0,0.75);\n    aside {\n      transform: translateY(0vh);\n    }\n    .close-button {\n      opacity: 1;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0,0,0,0.5);\n'], ['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0,0,0,0.5);\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  background: linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0));\n  width: 4rem;\n  height: 100vh;\n  position: absolute;\n  top: 2rem;\n  right: 0;\n  margin-right: -4rem;\n'], ['\n  pointer-events: none;\n  background: linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0));\n  width: 4rem;\n  height: 100vh;\n  position: absolute;\n  top: 2rem;\n  right: 0;\n  margin-right: -4rem;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-center;\n'], ['\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  height: 2rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  @media (max-width: 500px) {\n    flex-direction: column;\n    justify-content: default;\n  }\n'], ['\n  height: 2rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  @media (max-width: 500px) {\n    flex-direction: column;\n    justify-content: default;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  height: 2rem;\n  width: 90vw;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  text-shadow: black 2px 2px 4px;\n  font-size: 2rem;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 5vw;\n  margin-top: -2rem;\n  div {\n    line-height: 2rem;\n  }\n  .fa {\n    margin-bottom: 1rem;\n  }\n  :hover {\n    color: gold;\n  }\n'], ['\n  height: 2rem;\n  width: 90vw;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  text-shadow: black 2px 2px 4px;\n  font-size: 2rem;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 5vw;\n  margin-top: -2rem;\n  div {\n    line-height: 2rem;\n  }\n  .fa {\n    margin-bottom: 1rem;\n  }\n  :hover {\n    color: gold;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: white;\n  cursor: pointer;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  z-index: 40;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    color: gold;\n  }\n  @media (max-width: 500px) {\n    align-self: flex-end;\n  }\n'], ['\n  color: white;\n  cursor: pointer;\n  font-size: 2rem;\n  text-shadow: black 2px 2px 4px;\n  z-index: 40;\n  .fa {\n    margin-left: 0.5em;\n  }\n  &:hover {\n    color: gold;\n  }\n  @media (max-width: 500px) {\n    align-self: flex-end;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  pointer-events: none;\n  width: 100vw;\n  height: 100vh;\n  box-sizing: border-box;\n  background-image: ', ';\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  padding: 0;\n  margin: 0;\n  padding-top: 2rem;\n'], ['\n  pointer-events: none;\n  width: 100vw;\n  height: 100vh;\n  box-sizing: border-box;\n  background-image: ', ';\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  padding: 0;\n  margin: 0;\n  padding-top: 2rem;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  pointer-events: auto;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n'], ['\n  pointer-events: auto;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n'], ['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  height: 1rem;\n  width: 1rem;\n'], ['\n  height: 1rem;\n  width: 1rem;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _content = require('../content/content');

var _content2 = _interopRequireDefault(_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // TODO: Custom link colors

var Wrapper = _styledComponents2.default.div(_templateObject);

var Underbar = _styledComponents2.default.aside(_templateObject2);

var Shade = _styledComponents2.default.div(_templateObject3);

var Dialog = _styledComponents2.default.aside(_templateObject4);

var Header = _styledComponents2.default.div(_templateObject5);

var MyGiftCardsButton = _styledComponents2.default.div(_templateObject6);

var CloseButton = _styledComponents2.default.div(_templateObject7);

var Background = _styledComponents2.default.div(_templateObject8, function (props) {
  return 'url(' + props.image + ')';
});

var ScrollPane = _styledComponents2.default.div(_templateObject9);

var GridSizer = _styledComponents2.default.div(_templateObject10);

var Space = _styledComponents2.default.div(_templateObject11);

/** @class GiftCardTray
  * A component for dispaying the gift card details
  * @prop {URLString} background (optional) - a background image to display behind the showbag contents
  */

var GiftCardTray = function (_Component) {
  _inherits(GiftCardTray, _Component);

  /** @constructor
    * Creates a new instance of BoothListing
    */
  function GiftCardTray(props) {
    _classCallCheck(this, GiftCardTray);

    var _this = _possibleConstructorReturn(this, (GiftCardTray.__proto__ || Object.getPrototypeOf(GiftCardTray)).call(this, props));

    _this.state = {
      visible: false
    };
    return _this;
  }
  /** @method componentWillMount
    * Adds the show function to the global vexpo.showbag object
    * and starts listening for navigation events (in which case we hide)
    */


  _createClass(GiftCardTray, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.giftCards) window.vexpo.giftCards = {};
      window.vexpo.giftCards.show = function () {
        return _this2.setState({
          visible: true
        });
      };
      if (window.vexpo.history) {
        this.unlisten = window.vexpo.history.listen(function (location, action) {
          _this2.setState({ visible: false });
        });
      }
    }
    /** @method componentWillUnmount
      * Stops listening for navigation events.
      */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unlisten) this.unlisten();
    }
    /** @method render
      * Renders the showbag contents.
      */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var contents = (this.props.contents || []).map(function (item, index) {
        return _react2.default.createElement(_content2.default, _extends({ key: index }, item));
      });
      var masonryOptions = {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPostion: 'true',
        resize: 'true',
        disableImagesLoaded: true,
        updateOnEachImageLoad: false
      };
      var label = [_react2.default.createElement(_reactFontawesome2.default, { name: 'money', style: { marginTop: "1rem" } }), _react2.default.createElement(Space, null), 'D', 'I', 'S', 'C', 'O', 'U', 'N', 'T', _react2.default.createElement(Space, null), 'C', 'O', 'U', 'P', 'O', 'N', 'S'].map(function (c, index) {
        return _react2.default.createElement(
          'div',
          { key: index },
          c
        );
      });
      return _react2.default.createElement(
        Wrapper,
        { id: 'showbag', className: this.state.visible ? 'active' : '' },
        _react2.default.createElement(
          Underbar,
          { id: 'Underbar' },
          _react2.default.createElement(Shade, null),
          _react2.default.createElement(
            MyGiftCardsButton,
            { onClick: function onClick() {
                return _this3.setState({ visible: true });
              } },
            label
          ),
          _react2.default.createElement(
            Header,
            { id: 'header' },
            _react2.default.createElement(
              CloseButton,
              { className: 'close-button', onClick: function onClick() {
                  return _this3.setState({ visible: false });
                } },
              'CLOSE',
              _react2.default.createElement(_reactFontawesome2.default, { name: 'times' })
            )
          ),
          _react2.default.createElement(
            Background,
            { image: this.props.background },
            _react2.default.createElement(
              ScrollPane,
              null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return GiftCardTray;
}(_react.Component);

exports.default = GiftCardTray;


GiftCardTray.propTypes = {
  background: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/gift-cards/gift-cards-tray.js
// module id = 1366
// module chunks = 0